/* eslint-disable */
import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import './polyfill/arrayFind';
import './polyfill/dataset';
import './polyfill/arrayFrom';



/**
 * App
 * 
 */
import './modules/onePageAjax';
import SmoothScroll from './modules/smoothScroll';
import Paralax from './modules/paralax';
import sprite from './modules/spriteTitle';
import RevealAnimation from './modules/revealAnimation';
import Reveal from './modules/reveal';

// set scroll to 0 and add smooth scroll behavior
window.scrollTo(0,0);
document.querySelector('html').style.scrollBehavior = 'smooth';

// start splash screen animation after 5ms
const splash_screen = document.querySelector('.splash_screen');
function start(){
    setTimeout(() => {    
        splash_screen.classList.add("start");
    }, 300);
    setTimeout(() => {
        splash_screen.classList.add('hide');
        splash_screen.addEventListener('transitionend', () => splash_screen.remove(), {once: true});
        RevealAnimation(document, [
            {
                selector: ['.hero-page .bottle-wrapper'],
                animation: {
                    name: 'fromBottomBig',
                    duration: 1.8,
                    delay: .8
                }
            },
            {
                selector: ['.hero-page h2'],
                animation: {
                    name: 'fromOpacity',
                    duration: 1.8,
                    delay: 1.4
                }
            },
            {
                selector: ['.block-intro .media, .block-intro .visu, .block-intro .content'],
                animation: {
                    name: 'fromBottom',
                    duration: 1.2
                }
            },
            {/*.hero-section h2,*/
                selector: [' .hero-section .intro, .block-visu-full, .block-text h3, .block-text p'],
                animation: {
                    name: 'fromBottom',
                    duration: 1.2
                }
            },
            {
                selector: ['.block-content-mixed .media, .block-content-mixed .content, .block-video'],
                animation: {
                    name: 'fromBottom',
                    duration: 1.2
                }
            },
            {
                selector: ['.block-terroir .label, .block-terroir .map, .list-push-press li,.block-push-press .header, .block-contact .field'],
                animation: {
                    name: 'fromBottom',
                    duration: 1.2
                }
            },
        ]);
    }, 2800);
}


// majorite pour acceder au site
const age_gate = document.querySelector('.age_gate');
const btn_age_gate = age_gate.querySelector('.cta');
btn_age_gate.onclick = () => {
    age_gate.classList.add('hide');
    var date = new Date();
    date.setTime(date.getTime() + 31104000000);
    document.cookie = 'ageGate=true;expires=' + date.toGMTString() + ';path=/';
    start();
}

//
const age_gate_cookie = document.cookie.indexOf('ageGate=true') > -1 || localStorage.getItem('ageGate') === true;
if(age_gate_cookie){
    age_gate.remove();
    start();
}else{
    age_gate.style.display = 'flex';
}

// start animation reveal when splashscreen animation end


// add smooth scroll, paralax effects and title animated on window load
window.onload = () => { 
    const paralax = new Paralax([
        {
            el: ['.bottle-wrapper img'],
            strenght: 160
        },
        {
            el: ['.portal'],
            strenght: 60
        },
       {
            el: ['.block-intro .visu picture'],
            strenght: 40
    
        },
        {
            el: ['.media video, .media picture'],
            strenght: 80
        },
  
       {
            el: ['.block-visu-full .visu picture'],
            strenght: 60,
            type: "imgBgOffset"
        },
        {
            el: ['.block-content-mixed video, .block-content-mixed picture'],
            strenght: 150
        }
    ]);
    
    SmoothScroll(scrollY => paralax.run(scrollY));

    Reveal({
        once: true,
        items: document.querySelectorAll('.title-sprite'),
        onenter: el => sprite(el)
    });
};

// video play just on viewport
Reveal({
    items: document.querySelectorAll('video'),
    onenter: el => el.play(),
    onleave: el => el.pause()
});

// rgpd
import Rgpd from'./modules/rgpd';
Rgpd(cat => {
	console.log('cookies ' + cat + ' enabled');
	if(cat == 'statistiques'){
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
        ga('create', ParamsData.gtag_key, 'auto');
        ga('send', 'pageview');
        
        // add ip
        const el = document.querySelector('.rgpd-manage');
        const nonce = el.getAttribute('data-nonce');
        const action = el.getAttribute('data-action');
        var formData = new window.FormData();
        formData.append("nonce", nonce);
        formData.append("action", action);
        const xhr = new XMLHttpRequest();
        xhr.open("POST", ParamsData.wp_ajax_url);
        xhr.onreadystatechange = () => {};
        xhr.send(formData);
	}
});

/**
 * 
 * conditionner
 * 
 */

import * as conditioner from 'conditioner-core/conditioner-core.min';

document.documentElement.className = 'js';

conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
    // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./modules/${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);
